<template lang="pug">
  CommonSection(v-if="company" title="Сотрудники" :back="{ title: company.name, name: 'company-list', params: { companyId: $route.params.companyId } }")
    template(#button)
      .b-company-tile {{ company.name }}
        AvatarEditable._avatar(:editable="false" :avatar="company.avatar" placeholder="no-avatar-project")
      Btn(dark @click="selectUsers" v-if="isOwner || isDeputy") Добавить сотрудников
      UserSelectPopup2(ref="userSelectPopup")
      UserDetailPopup(ref="userDetailPopup")
        CompanyEmployeeForm(ref="userForm")
    EmptyList(v-if="!items.length") Нет сотрудников
    .b-company-employee-list-page(v-else)
      ._header
        BaseInput._filter(label="Поиск" v-model="search")
      ._items
        ContactTile._item(
          v-for="item in itemsFiltered"
          :key="item['@id']"
          :item="item"
          :editable="true"
          :menu="getMenu(item)"
          emitClick
          @click="openUserDetail(item)"
        )
</template>

<script>
import model from '@/model/company';

import CommonSection from '@/components/CommonSection.vue';
import ContactTile from '@/components/ContactTile.vue';
import UserSelectPopup2 from '@/components/UserSelectPopup2.vue';
import EmptyList from '@/components/ui/EmptyList.vue';
import BaseInput from '@/components/BaseInput.vue';
import UserDetailPopup from '@/components/UserDetailPopup.vue';
import CompanyEmployeeForm from '@/components/company/CompanyEmployeeForm.vue';
import AvatarEditable from '@/components/AvatarEditable.vue';

export default {
  name: 'CompanyEmployeeListPage',
  components: {AvatarEditable, EmptyList, UserSelectPopup2, ContactTile, CommonSection, BaseInput, UserDetailPopup, CompanyEmployeeForm },
  data() {
    return {
      search: '',
    };
  },
  computed: {
    currUser() { return this.$store.state.auth.user; },
    company() { return this.$store.getters['company/withMembers']; },
    deputies() { return this.company.deputies ?? [] },
    isOwner() { return this.company?.owner?.id === this.currUser.id },
    isDeputy() { return this.deputies.find(e => e.user.id === this.currUser.id) },
    items() {  return this.$store.state.company?.employees ?? []; },
    itemsFiltered() {
      const prepare = str => str.toLowerCase().replace(/\s/g, '');
      const search = prepare(this.search);

      return this.items.filter(e => !search || prepare(e.user.name + e.user.surname).includes(search));
    },
  },
  methods: {
    async openUserDetail(employee) {
      this.$refs.userDetailPopup.open(employee.user);
      this.$nextTick(() => {
        const initPosition = this.isOwner || this.isDeputy ? (employee.position ?? '') : null;
        const onFinish = (role, position) => {
          if (position !== null && position !== initPosition) this.$store.dispatch('company/updateEmployeePosition', { employee, position });
          this.$refs.userDetailPopup.close();
        };
        this.$refs.userForm.init(null, initPosition, onFinish);
      });
    },
    async selectUsers() {
      const usersBeforeSelect = this.items.map((m) => m.user['@id']);
      const selectedUsers = await this.$refs.userSelectPopup.open(usersBeforeSelect, true, null);

      if (!selectedUsers) return;

      const filtered = selectedUsers
        .map(u => u['@id'])
        .filter(u => !usersBeforeSelect.includes(u))
      ;

      await this.$store.dispatch('company/addEmployees', filtered);
    },
    getMenu(item) {
      if (!this.isOwner && !this.isDeputy) return [];

      return [
          { text: 'Уволить', icon: 'trash', handler: () => { model.employeeDelete(item); } },
        ];
    },
  },
};
</script>


<style lang="scss" scoped>
.company-tile {
  display: flex;
  align-items: center;
  gap: 20px;
  font-size: 16px;
  margin-right: auto;

  &__avatar {
    width: 60px;
    height: 60px;
    border-width: 2px;
    border-radius: 16px;
    order: -1;
  }

  @media (max-width: 800px) {
    display: none;
  }
}

.company-employee-list-page {
  &__header {
    margin-bottom: 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &__filter {
    width: 400px;
    max-width: 100%
  }


  &__items {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 30px;
  }

  @media (max-width: 1200px) {
    &__items {
      grid-template-columns: 1fr 1fr;
      gap: 20px;
    }
  }

  @media (max-width: 768px) {
    &__items {
      grid-template-columns: 1fr;
      gap: 20px;
    }
  }
}
</style>
